import { IAuthenticatorService } from '../authenticator-service';
import { AuthenticateMode, ILoginProfile } from '../models';
import { AuthenticatePartialComponent } from './authenticate-partial-component';

export class AuthenticateProfilePartialComponent extends AuthenticatePartialComponent {
  private email: string;
  private password: string;
  private remember: boolean;
  private profiles: ILoginProfile[];

  private readonly profilesElement: HTMLElement;
  private readonly profileElementTemplate: HTMLElement;

  constructor(rootElement: string | HTMLElement, authenticator?: IAuthenticatorService) {
    super(rootElement, authenticator);

    this.profilesElement = this.querySelector('.partnernet-login-panel__profilelist');
    const profileElement: HTMLElement = this.querySelector('.partnernet-login-panel__profileitem');
    this.profileElementTemplate = profileElement.cloneNode(true) as HTMLElement;
    profileElement.parentNode.removeChild(profileElement);
  }

  public show(...args: any[]): void {
    super.show(args);

    this.email = args[0] as string;
    this.password = args[1] as string;
    this.remember = args[2] as boolean;
    this.profiles = args[3] as ILoginProfile[];

    this.profilesElement.innerHTML = '';
    for (const profile of this.profiles) {
      const profileElement: HTMLElement = this.profileElementTemplate.cloneNode(true) as HTMLElement;

      profileElement.querySelector('.partnernet-login-panel__profilecountry').innerHTML = profile.CrmCountry;
      profileElement.dataset.crmContactId = profile.CrmContactId;

      const roleElementTemplate: HTMLElement = profileElement.querySelector('.partnernet-login-panel__roleitem');
      roleElementTemplate.parentNode.removeChild(roleElementTemplate);
      for (const role of profile.Roles) {
        const roleLoopElement: HTMLElement = roleElementTemplate.cloneNode(true) as HTMLElement;

        roleLoopElement.innerHTML = role;
        profileElement.appendChild(roleLoopElement);
      }

      profileElement.addEventListener(
        'click',
        (ev: MouseEvent): void => {
          ev.preventDefault();
          const profileId: string = profileElement.dataset.crmContactId;
          const crmProfile: ILoginProfile = this.profiles.filter(
            (p: ILoginProfile): boolean => p.CrmContactId === profileId,
          )[0];

          this.authenticator.login(this.email, this.password, this.remember, crmProfile).then(
            (): void => {
              if (typeof this.onSubmit !== 'function') {
                return;
              }

              this.onSubmit(AuthenticateMode.Login);
            },
          );
        },
      );

      this.profilesElement.appendChild(profileElement);
    }
  }
}
